module.exports = __webpack_public_path__ + "img/living0.d9779f3f.png";